import { useMemo } from 'react';
import { noop } from 'lodash';

import { StatisticsOrder, StatisticsOrderQuery } from '@dreryk/egabinet-statistics-frontend-api';

import {
   LazyLoadedDataConfigurationByCqrsQuery,
   useLazyLoadedDataConfigurationByCqrsQuery,
} from '@dreryk/drerykweb-main-frontend';
import { dateTimeFormatter } from '@dreryk/react-common';
import {
   createDynamicColumnsWidth,
   JustifyContent,
   TableColumnConfiguration,
   ValueRendererProps,
} from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../translations';

import { RangeCell } from './cells/RangeCell';
import { ActionsCell } from './cells/ActionsCell';
import { StatusCell } from './cells/StatusCell';
import { NameCell } from './cells/NameCell';

export const useStatisticsOrderColumns = (): TableColumnConfiguration<StatisticsOrder>[] => {
   return useMemo(() => {
      const columnsWidth = createDynamicColumnsWidth({
         name: '100%',
         created: '160px',
         range: '200px',
         status: '165px',
         actions: '88px',
      });

      return [
         {
            label: statisticsTranslationKeys.orderTable.name,
            width: columnsWidth.name,
            name: 'name',
            accessor: noop,
            renderer: ({ bean }: ValueRendererProps<StatisticsOrder>) => (
               <NameCell name={bean.name} additionalDescription={bean.additionalDescription ?? undefined} />
            ),
         },
         {
            label: statisticsTranslationKeys.orderTable.created,
            width: columnsWidth.created,
            accessor: 'created',
            name: 'created',
            formatter: dateTimeFormatter,
         },
         {
            label: statisticsTranslationKeys.orderTable.range,
            width: columnsWidth.range,
            name: 'range',
            sortingDisabled: true,
            accessor: noop,
            renderer: ({ bean }: ValueRendererProps<StatisticsOrder>) => <RangeCell range={bean.range} />,
         },
         {
            label: statisticsTranslationKeys.orderTable.status,
            width: columnsWidth.status,
            name: 'status',
            accessor: 'status',
            renderer: ({ bean }: ValueRendererProps<StatisticsOrder>) => <StatusCell status={bean.status} />,
         },
         {
            label: '',
            width: columnsWidth.actions,
            name: 'actions',
            accessor: noop,
            sortingDisabled: true,
            justifyContent: JustifyContent.END,
            renderer: ({ bean }: ValueRendererProps<StatisticsOrder>) => (
               <ActionsCell statisticsId={bean.id} status={bean.status} />
            ),
         },
      ];
   }, []);
};

export const useStatisticsOrderDataConfiguration = (): LazyLoadedDataConfigurationByCqrsQuery<StatisticsOrder> => {
   return useLazyLoadedDataConfigurationByCqrsQuery<StatisticsOrder>(() => {
      return new StatisticsOrderQuery();
   });
};
